import { darken, lighten, useTheme } from "@mui/material/styles";

import List from "@mui/material/List";
import { useMediaQuery } from "@mui/material";

export const WidgetList = props => {
  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <List
      sx={[
        {
          margin: theme.spacing(1),
          marginBottom: theme.spacing(2),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: theme.spacing(2),
            borderRadius: theme.spacing(1),
          },
          "&:hover::-webkit-scrollbar": {
            width: theme.spacing(2),
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: theme.spacing(1),
            backgroundColor: darken(theme.palette.commonground.main, 0.4),
            backgroundClip: "content-box",
          },
          "&::-webkit-scrollbar-thumb": {
            opacity: "0.5",
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
          },
          "&:hover::-webkit-scrollbar-thumb": {
            backgroundColor: lighten(theme.palette.secondary.main, 0.2),
          },
          overflowX: "hidden",
        },
        mobileLayout && {
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(0),
          marginBottom: theme.spacing(0),
        },
      ]}
    >
      {props.children}
    </List>
  );
};

export default WidgetList;
